import React, { useEffect, useState, Suspense } from "react";
import { getResources } from "../requests";
import { ResourcesType } from "../types";
import "../styles/resources.css";
import { CircularProgress } from "@material-ui/core";
import { Helmet } from "react-helmet";
const Resources = React.lazy(() => import("../components/Resources"));

export default function ResourcesPage() {
  const [resourcesData, setResources] = useState<ResourcesType>([
    { title: "", resource_content: "" },
  ]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    getResources().then((data) => {
      setResources(data["data"]);
      setLoading(false);
    });
  }, []);

  return (
    <div>
      <Helmet>
        <title>Resources</title>
        <meta
          name="Resources"
          content="Additional resources that service providers have found useful"
        />
      </Helmet>

      {isLoading ? (
        <div style={{ paddingTop: "5em" }}>
          <CircularProgress />
        </div>
      ) : (
        <Suspense fallback={<CircularProgress />}>
          <div
            style={{
              paddingTop: "5em",
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Resources resourceArr={resourcesData} />
          </div>
        </Suspense>
      )}
    </div>
  );
}
